export default __webpack_public_path__ + "static/media/cartao_empresarial.d96da651.png";